import { ReloadIcon } from "assets/icons";
import Board from "components/Common/Board/Board";
import Button from "components/foundation/Button";
import React from "react";
import styled from "styled-components";

interface DocumentPageHeaderProps {
  title: string;
  onFilterResetClick: () => void;
}

const DocumentPageHeader = ({
  title,
  onFilterResetClick,
}: DocumentPageHeaderProps) => {
  return (
    <DocumentPageHeaderLayout>
      <h1>{title}</h1>

      <Button variant="tertiary" size="large" onClick={onFilterResetClick}>
        태그 새로고침
        <ReloadIcon />
      </Button>
    </DocumentPageHeaderLayout>
  );
};

export default DocumentPageHeader;

const DocumentPageHeaderLayout = styled(Board)`
  padding: 3rem 4rem;

  display: flex;
  justify-content: space-between;

  h1 {
    font-size: 28px;
    font-weight: 600;
    line-height: 36px; /* 128.571% */
    letter-spacing: -0.56px;
  }

  button {
    ${({ theme }) => theme.typography.body1.semibold};
    color: ${({ theme }) => theme.color.text.secondary};
  }
`;
